import SafeAnchor from './SafeAnchor';
export default SafeAnchor;